module.exports = "/assets/2ed4079482c069f7a8afddac08b398fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/4J.png
// module id = 1036
// module chunks = 0